import { CoreApi, Product, ProductPartial } from '@inter-ikea-storageone/range';
import { isSelectedColorRequirementFulfilled } from './util';
import { ComponentIds } from '@inter-ikea-core/core';
import { getRightUprightsOffsetFromLeft } from '@inter-ikea-storagetwo/boaxel/dist/functions/interactiveBoaxelSection';
import { getUprights } from '@inter-ikea-storagetwo/boaxel/dist/utils/sectionsHelpers';

export const requiresSelectedColour = () => (product: Product | ProductPartial) =>
  isSelectedColorRequirementFulfilled(product);

export const requireSelectedWidth = ({ core }: CoreApi) => (product: Product | ProductPartial) => {
  const mountingRail = core.services.entityManager.entities.find(entity => {
    return entity.hasComponent(ComponentIds.SELECTED_COMPONENT_ID) && entity.hasComponent(106016);
  });
  if (!mountingRail) throw new Error('No mounting rail');

  const { rightUpright } = getUprights(mountingRail);
  if (!rightUpright) throw new Error('No upright');

  const width = getRightUprightsOffsetFromLeft(mountingRail, rightUpright);

  if (width < 600 && product.communicatedDimensions.width < 600) return true;
  return product.communicatedDimensions.width === width;
};
